Vue.asyncComponent('cms-focal-point-editor', {
    data() {
        return {
            startPosition: {
                x: null,
                y: null,
            },
            currentFocalPoint: {
                x: 50,
                y: 50,
            },
            dragging: false,
        };
    },
    props: {
        mediaId: {
            type: String,
            required: true
        },
        media: {
            type: Object,
            required: true,
        },
        thumbnail: {
            type: String,
            required: true,
        },
        focalPoint: {
            type: Object,
        },
    },
    methods: {
        /**
         * Start drag focal point
         * @param e
         */
        startDragFocalPoint(e) {
            document.addEventListener('mouseup', this.stopDragFocalPoint);
            document.addEventListener('mousemove', this.dragFocalPoint);
            this.startPosition.x = e.clientX;
            this.startPosition.y = e.clientY;
            this.dragging = true;
        },
        /**
         * stop drag focal point
         */
        stopDragFocalPoint() {
            document.removeEventListener('mouseup', this.stopDragFocalPoint);
            document.removeEventListener('mousemove', this.dragFocalPoint);
            this.dragging = false;

            this.submitFocalPoint();
        },
        /**
         * Drag focal point
         * @param e
         */
        dragFocalPoint(e) {
            e.preventDefault();

            const containerRect = this.$refs.container.getBoundingClientRect();
            const x = e.clientX - containerRect.left;
            const y = e.clientY - containerRect.top;

            // cacluclate the coordinates in percentage rounded to 2 decimals
            let transformX = Math.round((x / containerRect.width) * 10000) / 100;
            let transformY = Math.round((y / containerRect.height) * 10000) / 100;

            // Check if the percentage is not smaller then 0 and not bigger then 100
            transformX = this.checkMinMax(transformX);
            transformY = this.checkMinMax(transformY);

            this.currentFocalPoint.x = transformX;
            this.currentFocalPoint.y = transformY;
        },
        /**
         * Check minmax
         * @param value
         * @return {*|number}
         */
        checkMinMax(value) {
            if (value <= 0) {
                return 0;
            }
            if (value >= 100) {
                return 100;
            }

            return value;
        },
        /**
         * Submit the new focal point
         * @return {Promise<void>}
         */
        async submitFocalPoint() {
            const url = this.$getSetting('paths.baseCms') + '/media/' + this.mediaId + '/set-focal-point';
            const result = await this.$post(url, this.currentFocalPoint);

            if (result.success) {
                this.$actionHandler.handle(result.todos, this);
            }
        },
        /**
         * Submit the new focal point
         * @return {Promise<void>}
         */
        async removeFocalPoint() {
            const url = this.$getSetting('paths.baseCms') + '/media/' + this.mediaId + '/remove-focal-point';
            const result = await this.$post(url);

            if (result.success) {
                this.currentFocalPoint = {
                    x: 50,
                    y: 50,
                };
                this.$actionHandler.handle(result.todos, this);
            }
        }
    },
    mounted() {
        if(this.focalPoint) {
            this.currentFocalPoint = this.focalPoint;
        }
    }
}, 'cms/media/cms-focal-point-editor.html');